import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckMarkInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.2 16.6c.19.25.49.4.8.4h.04a.99.99 0 0 0 .81-.47l5-8a1.003 1.003 0 0 0-1.7-1.06l-4.23 6.76L8.8 11.4c-.33-.44-.96-.53-1.4-.2s-.53.96-.2 1.4z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 12c0 5.51 4.49 10 10 10s10-4.49 10-10S17.51 2 12 2 2 6.49 2 12m2 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckMarkInCircle;
